/* tslint:disable */
import {
  Users,
  Worker
} from '../index';

declare var Object: any;
export interface WorkerShiftInterface {
  "Name"?: string;
  "sfdcId"?: string;
  "RecordTypeId"?: string;
  "OwnerId"?: string;
  "LastModifiedById"?: string;
  "CurrencyIsoCode"?: string;
  "CreatedById"?: string;
  "Description__c"?: string;
  "End_AM_PM__c"?: string;
  "End_Time__c"?: string;
  "End_Time_zone__c"?: string;
  "Start_AM_PM__c"?: string;
  "Start_Time__c"?: string;
  "Start_Time_zone__c"?: string;
  "Worker_Shift_Code__c"?: string;
  "Worker_Shift_Type__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  owner?: Users;
  worker?: Worker[];
}

export class WorkerShift implements WorkerShiftInterface {
  "Name": string;
  "sfdcId": string;
  "RecordTypeId": string;
  "OwnerId": string;
  "LastModifiedById": string;
  "CurrencyIsoCode": string;
  "CreatedById": string;
  "Description__c": string;
  "End_AM_PM__c": string;
  "End_Time__c": string;
  "End_Time_zone__c": string;
  "Start_AM_PM__c": string;
  "Start_Time__c": string;
  "Start_Time_zone__c": string;
  "Worker_Shift_Code__c": string;
  "Worker_Shift_Type__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  owner: Users;
  worker: Worker[];
  constructor(data?: WorkerShiftInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `WorkerShift`.
   */
  public static getModelName() {
    return "WorkerShift";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of WorkerShift for dynamic purposes.
  **/
  public static factory(data: WorkerShiftInterface): WorkerShift{
    return new WorkerShift(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'WorkerShift',
      plural: 'WorkerShifts',
      path: 'WorkerShifts',
      idName: 'id',
      properties: {
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "RecordTypeId": {
          name: 'RecordTypeId',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "Description__c": {
          name: 'Description__c',
          type: 'string'
        },
        "End_AM_PM__c": {
          name: 'End_AM_PM__c',
          type: 'string'
        },
        "End_Time__c": {
          name: 'End_Time__c',
          type: 'string'
        },
        "End_Time_zone__c": {
          name: 'End_Time_zone__c',
          type: 'string'
        },
        "Start_AM_PM__c": {
          name: 'Start_AM_PM__c',
          type: 'string'
        },
        "Start_Time__c": {
          name: 'Start_Time__c',
          type: 'string'
        },
        "Start_Time_zone__c": {
          name: 'Start_Time_zone__c',
          type: 'string'
        },
        "Worker_Shift_Code__c": {
          name: 'Worker_Shift_Code__c',
          type: 'string'
        },
        "Worker_Shift_Type__c": {
          name: 'Worker_Shift_Type__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        owner: {
          name: 'owner',
          type: 'Users',
          model: 'Users',
          relationType: 'belongsTo',
                  keyFrom: 'CreatedById',
          keyTo: 'sfdcId'
        },
        worker: {
          name: 'worker',
          type: 'Worker[]',
          model: 'Worker',
          relationType: 'hasMany',
                  keyFrom: 'sfdcId',
          keyTo: 'Global_Shift_Equivalent_Schedule_GSES__c'
        },
      }
    }
  }
}
